import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import es from "./es.json";

export const SUPPORTED_LANGUAGES = ["en", "es"] as const;

const browserLanguage = () => {
  const code = (navigator.language || "en").slice(0, 2);
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(code)
    ? code
    : "en";
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: { en: { translation: en }, es: { translation: es } },
    lng: localStorage.getItem("pft.language") || browserLanguage(),
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    returnNull: false,
  });
}

export const setLanguage = (lng: string) => {
  localStorage.setItem("pft.language", lng);
  return i18n.changeLanguage(lng);
};

export default i18n;
